import getConfig from 'next/config';
import Script from 'next/script';

const { publicRuntimeConfig } = getConfig();

const ReCaptchaScript: React.FC = () => (
  <Script src={`https://www.google.com/recaptcha/api.js?render=${publicRuntimeConfig.recaptchaPublicKey}`} />
);

export default ReCaptchaScript;
